import {
  UPDATE_SEARCH_TERMS,
  UPDATE_SEARCH_TERMS_ERROR,
} from '../actions/multiSearch';

export const initialState = {
  isEditable: true,
  searchTerms: [],
  error: null,
};

export default function multiSearch(state = initialState, action) {
  switch (action.type) {
    case UPDATE_SEARCH_TERMS:
      return { ...state, searchTerms: action.searchTerms };
    case UPDATE_SEARCH_TERMS_ERROR:
      return { ...state, error: action.error };
    default:
      return state;
  }
}
